import React from "react";

type PriceStatusChipProps = {
  status?: string | null;
};

/**
 * Bootstrap badges aligned with Item list Sync Status (Synced / Not Synced).
 */
const PriceStatusChip: React.FC<PriceStatusChipProps> = ({ status }) => {
  if (status === "new_price") {
    return (
      <span className="badge bg-primary text-white">New Price</span>
    );
  }

  if (status === "price_updated") {
    return (
      <span className="badge bg-warning text-dark">Price Updated</span>
    );
  }

  return "";
};

export default PriceStatusChip;
